module.exports = __webpack_public_path__ + "static/media/whitePipeline.aa689d77.svg";